import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  TextField,
  Button,
} from "@material-ui/core";
import { subtareasApi } from "src/services/subtareasApi";
import { AlertaModalV2 } from "../AlertaSwall";
import { useSnackbar } from "src/components/snackbar";
import { icon, text } from "@fortawesome/fontawesome-svg-core";

export default function EditarSubTareaDialog(props) {
  const { open, setOpen, subTarea } = props;

  const [editarSubtarea] = subtareasApi.useUpdateSubtareaMutation();
  const [nombreSubTarea, setNombreSubTarea] = useState(subTarea.nombre);
  const { enqueueSnackbar } = useSnackbar();

  const handleClose = () => {
    setOpen(false);
  };

  const editar = () => {
    AlertaModalV2({
      title: "¿Editar subtarea?",
      text: "los cambios seran guardados, ¿Está seguro?",
      confirmButtonText: "Sí, editar",
      cancelButtonText: "Cancelar",
      icon: "question",
    })
      .fire()
      .then((result) => {
        if (result.isConfirmed) {
          editarSubtarea({
            nombre: String(nombreSubTarea).toUpperCase(),
            idSubtarea: subTarea.id,
          })
            .unwrap()
            .then(() => {
              enqueueSnackbar("Subtarea editada", {
                variant: "success",
              });
              setOpen(false);
            })
            .catch(() => {
              enqueueSnackbar("Error en el servidor", {
                variant: "error",
              });
            });
        }
      });
  };

  const handleChangeNombreSubTarea = (event) => {
    setNombreSubTarea(event.target.value);
  };

  return (
    <Dialog open={open} fullWidth maxWidth="md" id="dialogEditarSubtarea">
      <DialogTitle>Nueva Subtarea</DialogTitle>
      <DialogContent>
        <Stack style={{ marginTop: "10px" }}>
          <TextField
            value={nombreSubTarea}
            onChange={handleChangeNombreSubTarea}
            label="Nombre Subtarea"
            variant="outlined"
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cerrar</Button>
        <Button variant="contained" onClick={editar} autoFocus>
          Editar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
